var angularModule = angular.module('t2g.common.services.modalService', []);

module.exports = angularModule;

angularModule.factory('AppointmentModal', function($compile, $rootScope, $http, $templateCache) {
  var AppointmentModal = new Object();
  var scope = $rootScope.$new();
  var body = $(document).find('body');
  var modalHTML = '';

  /**
   * load the modal template file
   */
  $http.get('/app/modules/calendar/modal/AppointmentModalView.html').then(function(response) {
    $templateCache.put('AppointmentModalView.html', response.data);
  });

  /**
   * show the modal
   */
  AppointmentModal.open = function(appointment, object) {
    // load modal html
    modalHTML = $compile($templateCache.get('AppointmentModalView.html'))(scope);
    modalHTML.controller().setCurrentItem(appointment, object);
    body.append(modalHTML);

    $('#appointmentModal').modal({
      show: true,
      backdrop: 'static',
      keyboard: true,
    });
  };

  /**
   * hide the modal and clear the current model
   */
  AppointmentModal.close = function() {
    $('#appointmentModal').modal('hide');

    // remove modal html
    angular
      .element($('#appointmentModal'))
      .scope()
      .$destroy();
    $('#appointmentModal').remove();
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
  };

  return AppointmentModal;
});

angularModule.factory('PrivateAppointmentModal', function(
  $compile,
  $rootScope,
  $http,
  $templateCache,
) {
  var PrivateAppointmentModal = new Object();
  var scope = $rootScope.$new();
  var body = $(document).find('body');
  var modalHTML = '';

  /**
   * load the modal template file
   */
  $http
    .get('/app/modules/calendar/modal/PrivateAppointmentModalView.html')
    .then(function(response) {
      $templateCache.put('PrivateAppointmentModalView.html', response.data);
    });

  /**
   * show the modal
   */
  PrivateAppointmentModal.open = function(appointment, object) {
    // load modal html
    modalHTML = $compile($templateCache.get('PrivateAppointmentModalView.html'))(scope);
    modalHTML.controller().setCurrentItem(appointment, object);
    body.append(modalHTML);

    $('#PrivateAppointmentModal').modal({
      show: true,
      backdrop: 'static',
      keyboard: true,
    });
  };

  /**
   * hide the modal and clear the current model
   */
  PrivateAppointmentModal.close = function() {
    $('#PrivateAppointmentModal').modal('hide');

    // remove modal html
    angular
      .element($('#PrivateAppointmentModal'))
      .scope()
      .$destroy();
    $('#PrivateAppointmentModal').remove();
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
  };

  return PrivateAppointmentModal;
});

angularModule.factory('CourseAppointmentModal', function(
  $compile,
  $rootScope,
  $http,
  $templateCache,
) {
  var CourseAppointmentModal = new Object();
  var scope = $rootScope.$new();
  var body = $(document).find('body');
  var modalHTML = '';

  /**
   * load the modal template file
   */
  $http.get('/app/modules/calendar/modal/CourseAppointmentModalView.html').then(function(response) {
    $templateCache.put('CourseAppointmentModalView.html', response.data);
  });

  /**
   * show the modal
   */
  CourseAppointmentModal.open = function(appointment, object, showParticipants) {
    // load modal html
    modalHTML = $compile($templateCache.get('CourseAppointmentModalView.html'))(scope);
    modalHTML.controller().setCurrentItem(appointment, object, showParticipants);
    body.append(modalHTML);

    $('#CourseAppointmentModal').modal({
      show: true,
      backdrop: 'static',
      keyboard: true,
    });
  };

  /**
   * hide the modal and clear the current model
   */
  CourseAppointmentModal.close = function() {
    $('#CourseAppointmentModal').modal('hide');

    // remove modal html
    angular
      .element($('#CourseAppointmentModal'))
      .scope()
      .$destroy();
    modalHTML.remove();
    $('#CourseAppointmentModal')
      .destroy()
      .remove();
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
  };

  return CourseAppointmentModal;
});

angularModule.factory('EmployeeModal', function($compile, $rootScope, $http, $templateCache) {
  var EmployeeModal = new Object();
  var scope = $rootScope.$new();
  var body = $(document).find('body');
  var modalHTML = '';

  /**
   * load the modal template file
   */
  $http.get('/app/modules/object/modal/EmployeeModalView.html').then(function(response) {
    $templateCache.put('EmployeeModalView.html', response.data);
  });

  /**
   * show the modal
   */
  EmployeeModal.open = function(employee) {
    // load modal html
    modalHTML = $compile($templateCache.get('EmployeeModalView.html'))(scope);
    modalHTML.controller().setCurrentItem(employee);
    body.append(modalHTML);

    $('#employeeModal').modal({
      show: true,
      backdrop: 'static',
      keyboard: true,
    });
  };

  /**
   * hide the modal and clear the current model
   */
  EmployeeModal.close = function() {
    $('#employeeModal').modal('hide');

    // remove modal html
    angular
      .element($('#employeeModal'))
      .scope()
      .$destroy();
    modalHTML.remove();
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
  };

  return EmployeeModal;
});

angularModule.factory('ServiceModal', function($compile, $rootScope, $http, $templateCache) {
  var ServiceModal = new Object();
  var scope = $rootScope.$new();
  var body = $(document).find('body');
  var modalHTML = '';

  /**
   * load the modal template file
   */
  $http.get('/app/modules/service/modal/ServiceModal.html').then(function(response) {
    $templateCache.put('ServiceModal.html', response.data);
  });

  /**
   * show the modal
   */
  ServiceModal.open = function(service) {
    modalHTML = $compile($templateCache.get('ServiceModal.html'))(scope);
    body.append(modalHTML);
    modalHTML.controller().setCurrentItem(service);

    $('#serviceModal').modal({
      show: true,
      backdrop: 'static',
      keyboard: true,
    });
  };

  /**
   * hide the modal and clear the current model
   */
  ServiceModal.close = function() {
    $('#serviceModal').modal('hide');

    // remove modal html
    angular
      .element($('#serviceModal'))
      .scope()
      .$destroy();
    modalHTML.remove();
    $('.modal-backdrop').remove();
    $('body').removeAttr('class');
  };

  return ServiceModal;
});

angularModule.factory('ServiceGroupModal', function($compile, $rootScope, $http, $templateCache) {
  var ServiceGroupModal = new Object();
  var scope = $rootScope.$new();
  var body = $(document).find('body');
  var modalHTML = '';

  /**
   * load the modal template file
   */
  $http.get('/app/modules/service/modal/ServiceGroupModal.html').then(function(response) {
    $templateCache.put('ServiceGroupModal.html', response.data);
  });

  /**
   * show the modal
   */
  ServiceGroupModal.open = function() {
    modalHTML = $compile($templateCache.get('ServiceGroupModal.html'))(scope);
    body.append(modalHTML);

    $('#serviceGroupModal').modal({
      show: true,
      backdrop: 'static',
      keyboard: true,
    });
  };

  /**
   * hide the modal and clear the current model
   */
  ServiceGroupModal.close = function() {
    $('#serviceGroupModal').modal('hide');

    // remove modal html
    angular
      .element($('#serviceGroupModal'))
      .scope()
      .$destroy();
    modalHTML.remove();
    $('.modal-backdrop').remove();
    $('body').removeAttr('class');
  };

  return ServiceGroupModal;
});

angularModule.factory('CourseModal', function($compile, $rootScope, $http, $templateCache) {
  var CourseModal = new Object();
  var scope = $rootScope.$new();
  var body = $(document).find('body');
  var modalHTML = '';

  /**
   * load the modal template file
   */
  $http.get('/app/modules/course/modal/CourseModal.html').then(function(response) {
    $templateCache.put('CourseModal.html', response.data);
  });

  /**
   * show the modal
   */
  CourseModal.open = function(course) {
    modalHTML = $compile($templateCache.get('CourseModal.html'))(scope);
    modalHTML.controller().setCurrentItem(course);
    body.append(modalHTML);

    $('#courseModal').modal({
      show: true,
      backdrop: 'static',
      keyboard: true,
    });
  };

  /**
   * hide the modal and clear the current model
   */
  CourseModal.close = function() {
    $('#courseModal').modal('hide');

    // remove modal html
    angular
      .element($('#courseModal'))
      .scope()
      .$destroy();
    modalHTML.remove();
    $('.modal-backdrop').remove();
    $('body').removeAttr('class');
  };

  return CourseModal;
});



// WEBPACK FOOTER //
// ./src/app/common/services/ModalService.js